import React from 'react';
import type { ThreatProfile } from '../api/types.js';
import ThreatProfileForm, { type ThreatProfileFormProps } from './settings/ThreatProfileForm.js';

interface Props {
  open: boolean;
  /** Edit mode when given; remount (key) the modal when it changes so the form starts from the profile. */
  profile?: ThreatProfile;
  onClose: () => void;
  onSave: ThreatProfileFormProps['onSave'];
}

/** Threat profiles are created and edited from the main page (deleted from their card); this hosts the form in a modal. */
function ThreatProfileModal({ open, profile, onClose, onSave }: Props) {
  if (!open) return null;
  return (
    <div className="mov" onClick={onClose}>
      <div className="mod mod-profile" onClick={(e) => e.stopPropagation()}>
        <div className="mbd">
          <ThreatProfileForm profile={profile} onSave={onSave} onCancel={onClose} />
        </div>
      </div>
    </div>
  );
}

export default ThreatProfileModal;
